var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-modal', {
    attrs: {
      "visible": Boolean(_vm.file),
      "size": "md",
      "modal-class": "catalog-image-crop-dialog",
      "centered": "",
      "hide-header": "",
      "hide-footer": ""
    },
    on: {
      "hidden": function hidden($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_c('p', {
    staticClass: "catalog-image-crop__hint"
  }, [_vm._v("Arraste a foto dentro da moldura para ajustar o enquadramento.")]), _c('div', {
    staticClass: "catalog-image-crop__workspace"
  }, [_c('div', {
    staticClass: "catalog-image-crop__stage",
    style: {
      aspectRatio: _vm.aspectRatio
    }
  }, [_vm.source ? _c('vue-cropper', {
    ref: "cropper",
    attrs: {
      "src": _vm.source,
      "container-style": {
        width: '100%',
        height: '100%',
        aspectRatio: _vm.aspectRatio
      },
      "img-style": {
        display: 'block',
        width: '100%',
        height: '100%',
        objectFit: 'contain'
      },
      "aspect-ratio": _vm.aspectRatio,
      "view-mode": 1,
      "auto-crop-area": 0.84,
      "movable": true,
      "zoomable": true,
      "background": false,
      "guides": false,
      "center": false,
      "crop-box-movable": false,
      "crop-box-resizable": false,
      "toggle-drag-mode-on-dblclick": false,
      "drag-mode": "move",
      "crop": _vm.updateQuality,
      "ready": _vm.onReady,
      "zoom": _vm.onZoom
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "catalog-image-crop__zoom-rail",
    attrs: {
      "aria-label": "Controles de zoom"
    }
  }, [_c('button', {
    attrs: {
      "type": "button",
      "aria-label": "Aumentar zoom",
      "disabled": !_vm.baseZoom
    },
    on: {
      "click": function click($event) {
        return _vm.stepZoom(0.1);
      }
    }
  }, [_vm._v("+")]), _c('button', {
    attrs: {
      "type": "button",
      "aria-label": "Diminuir zoom",
      "disabled": !_vm.baseZoom
    },
    on: {
      "click": function click($event) {
        return _vm.stepZoom(-0.1);
      }
    }
  }, [_vm._v("−")])])]), _c('div', {
    staticClass: "catalog-image-crop__zoom mt-3"
  }, [_c('input', {
    attrs: {
      "type": "range",
      "min": _vm.minZoomLevel,
      "max": "3",
      "step": "0.01",
      "disabled": !_vm.baseZoom,
      "aria-label": "Zoom da foto"
    },
    domProps: {
      "value": _vm.zoomLevel
    },
    on: {
      "input": function input($event) {
        return _vm.setZoom($event.target.value);
      }
    }
  }), _c('button', {
    staticClass: "catalog-image-crop__reset",
    attrs: {
      "type": "button",
      "disabled": !_vm.baseZoom
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Restaurar")])]), _c('div', {
    staticClass: "catalog-image-crop__info mt-3"
  }, [_c('p', {
    staticClass: "catalog-image-crop__info-title"
  }, [_vm._v("Resolução da imagem")]), _vm.sourceDimensions.width && _vm.sourceDimensions.height ? _c('p', [_vm._v(" Original: " + _vm._s(_vm.sourceDimensions.width) + " × " + _vm._s(_vm.sourceDimensions.height) + " px ")]) : _c('p', [_vm._v("Carregando resolução...")]), _c('p', [_vm._v("Área selecionada: " + _vm._s(_vm.quality.width) + " × " + _vm._s(_vm.quality.height) + " px")]), _c('p', [_vm._v("Mínimo para o recorte: " + _vm._s(_vm.minCropWidth) + " × " + _vm._s(_vm.minCropHeight) + " px")]), _vm.qualityFeedback ? _c('p', {
    staticClass: "catalog-image-crop__feedback",
    class: _vm.quality.valid ? 'text-success' : 'text-warning',
    attrs: {
      "role": "status"
    }
  }, [_vm._v(" " + _vm._s(_vm.qualityFeedback) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "catalog-image-crop__actions"
  }, [_c('b-button', {
    attrs: {
      "variant": "light"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_vm._v(" Cancelar ")]), _c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": !_vm.quality.valid || _vm.applying
    },
    on: {
      "click": _vm.apply
    }
  }, [_vm._v(" Usar esta foto ")])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };